<template>
    <b-alert variant="secondary" dismissible :show="show" @dismissed="dismiss" class="notification-top">
        <b-list-group>
          <b-list-group-item :key="item.notificationId" v-for="item in items" :variant="priorityVariant[item.priority-1]" class="m-1">
            <b-img v-if="item.priority === 3" left src="~@/assets/images/danger-icon.svg" class="danger-notification-icon"/>
            <b-img v-else-if="item.priority === 2" left src="~@/assets/images/warning-icon.svg" class="warning-notification-icon"/>
            <b-img v-else src="~@/assets/images/info-icon.svg" left class="info-notification-icon"/>
            {{item.text}}
          </b-list-group-item>
        </b-list-group>
    </b-alert>
</template>

<script>
  import { EventBus } from '@/router/bus'
  import { getUser, getNotificationInfo, setNotificationInfo } from '@/utils/cookie'

  export default {
    data () {
      return {
        priorityVariant: ['info', 'warning', 'danger'],
        show: false,
        showList: false,
        items: []
      }
    },
    created () {
      EventBus.$on('notification', (data) => {
        // Filter incoming data to get only non-dismissed items
        this.items = this.getNondismissed(data)
        if (this.items.length === 0) {
          return
        }

        this.show = true
      })
      EventBus.$on('notification-close', () => {
        this.show = false
        this.items = []
      })
    },
    methods: {
      dismiss () {
        this.show = false
        this.updateDismissed()
        this.items = []
      },
      updateDismissed () {
        var notificationInfo = this.getCurrentNotificationInfo()

        for (var i = 0; i < this.items.length; i++) {
          notificationInfo.push(this.items[i].notificationId)
        }
        this.setCurrentNotificationInfo(notificationInfo)
      },
      setCurrentNotificationInfo (info) {
        var key = getUser()
        setNotificationInfo(key, info)
      },
      getNondismissed (data) {
        var notificationInfo = this.getCurrentNotificationInfo()
        var nondismissed = []
        for (var i = 0; i < data.length; i++) {
          if (!(notificationInfo.includes(data[i].notificationId))) {
            nondismissed.push(data[i])
          }
        }
        return nondismissed
      },
      getCurrentNotificationInfo () {
        var key = getUser()
        var notificationInfo = getNotificationInfo(key)

        if (notificationInfo == null) {
          notificationInfo = []
          // setNotificationInfo(key, notificationInfo)
        }

        return notificationInfo
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
    .notification-top {
        position: absolute;
        top: 64px;
        z-index: 100;
        border-radius: 0;
        margin-left: 5px;
        width: calc(100% - 10px);
    }

    .notification-item {
      margin-right: 4rem !important;
    }

    .danger-notification-icon {
      width: 28px;
      height: 28px;
      line-height: 32px;
      margin: 0px;
      margin-right: 15px;
    }

    .warning-notification-icon {
      width: 30px;
      height: 30px;
      margin: 0px;
      margin-right: 15px;
    }

    .info-notification-icon {
      width: 28px;
      height: 28px;
      margin: 0px;
      margin-right: 15px;
    }  
    
</style>




// WEBPACK FOOTER //
// NotificationContainer.vue?4092ce02